import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { ADD_FUNDS } from './constants';
import { useAddFundsModalContext } from './contexts/add-funds-modal-context-provider';
import { useTrackEvent, PageEvents } from '../tracking-events';

import messages from './messages';

const SubmitButton = ({ selectedTab }) => {
  const {
    autoFundEnabled,
    balanceThreshold,
    autoFundAmount,
    maxDailyFundings,
    fundAmount,
    useAsDefault,
    purchaseFunds,
    updateAutoFundsConfig,
    submitting,
    setSubmitting,
    currencyCode,
  } = useAddFundsModalContext();

  const trackSaveAutofundClick = useTrackEvent(PageEvents.MANAGE_AUTOFUND_CONFIG_SAVE);
  const trackAddFundsClick = useTrackEvent(PageEvents.CONFIRM_FUND_WALLET_CLICK);

  const onSubmit = async () => {
    setSubmitting(true);
    if (selectedTab === ADD_FUNDS) {
      trackAddFundsClick({ fundAmount, currencyCode, useAsDefault });
      await purchaseFunds(useAsDefault, fundAmount);
      setSubmitting(false);
      return;
    }

    trackSaveAutofundClick({
      autoFundEnabled,
      balanceThreshold,
      autoFundAmount,
      maxDailyFundings,
    });
    await updateAutoFundsConfig(autoFundEnabled, balanceThreshold, autoFundAmount, maxDailyFundings);
    setSubmitting(false);
  };

  return (
    <Button disabled={submitting} onClick={onSubmit} theme='primary'>
      <FormattedMessage {...messages.submit} />
    </Button>
  );
};

SubmitButton.propTypes = {
  selectedTab: PropTypes.string.isRequired,
};

export default SubmitButton;
